import { PickupCorporateSummary } from "@/domain/entities/ListPickupV2";
import { PickupCorporateAddress } from "@/domain/entities/PickupSchedule";

export function patchPickupSummaryAddress(
  summary: PickupCorporateSummary,
  address: PickupCorporateAddress
): PickupCorporateSummary {
  return new PickupCorporateSummary({
    ...summary,
    contactName: address.pcaName,
    contactPhone: address.pcaPhoneNumber,
    addressLine: address.pcaAddress
  });
}
